export enum FileType {
  PDF = 'pdf',
  XLS = 'xls',
  XLSX = 'xlsx',
}
